import { render, staticRenderFns } from "./PoiHours.vue?vue&type=template&id=606c247e"
import script from "./PoiHours.js?vue&type=script&lang=js&external"
export * from "./PoiHours.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports